/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { BlogCategoryFormModal } from './_modals/BlogCategoryFormModal'
import { BlogCategoryListModal } from './_modals/BlogCategoryListModal'
import { DeleteModal } from '../../components/modals/DeleteModal'
import BlogCategoryApi from '../../../infrastructure/api/BlogCategoryApi'

import { checkPermission, UserModel } from '../../modules/auth/models/UserModel'
import { RootState } from '../../../setup'
import { shallowEqual, useSelector } from 'react-redux'
import { PermissionEnum } from '../../../enums/PermissionEnum'

const BlogCategoryPage: FC = () => {
  const [itemId, setItemId] = useState(0)
  const [itemName, setItemName] = useState('')

  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const onClickItem = (value: number, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  async function deleteBlogCategory(itemId: number) {
    var response = await BlogCategoryApi.DeleteBlogCategory(itemId)
    setRefresh(refresh + 1)
  }
  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'></h3>
          {checkPermission(user, PermissionEnum.BlogCategoryCreate) &&
            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Click to add a category'
            >
              <a
                href='#'
                onClick={() => onClickItem(0, '', 'create')}
                className='btn btn-sm btn-light-primary'
              >
                <KTSVG
                  path='/media/icons/duotone/Code/Plus.svg'
                  className='svg-icon-3'
                />
                Add Category
              </a>
            </div>
          }
        </div>

        <div className='card-body py-3'>
          <BlogCategoryListModal refresh={refresh} onClickItem={onClickItem} />
          {(checkPermission(user, PermissionEnum.BlogCategoryCreate) || checkPermission(user, PermissionEnum.BlogCategoryUpdate)) &&
            <BlogCategoryFormModal itemId={itemId} show={showForm} handleClose={handleCloseForm} />
          }
          {checkPermission(user, PermissionEnum.BlogCategoryDelete) &&
            <DeleteModal
              itemId={itemId}
              itemName={itemName}
              handleClose={handleCloseDelete}
              show={showDelete}
              type='Blog Category'
              confirm={deleteBlogCategory}
            />
          }
        </div>
      </div>
    </>
  )
}

const BlogCategoryWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Blog Categories</PageTitle>
      <BlogCategoryPage />
    </>
  )
}

export { BlogCategoryWrapper }
